export default __webpack_public_path__ + "static/media/roadmapimg.aa7e4f88.png";